import { computed, ComputedRef, ref, Ref } from 'vue'
import {
  DropDownMenuItemProps,
} from "frontcore/views/drop-down/domain/types"

export type GroupedDropDownMenuItemProps = DropDownMenuItemProps & { showGroupLabel: boolean }

export interface IDropDownGroupedItemsUseCase {
  groupedOptionList: ComputedRef<GroupedDropDownMenuItemProps[]>
}

const useDropDownGroupedItems = (optionList: Ref<DropDownMenuItemProps[]>, keepOrder: Ref<boolean> = ref(false)): IDropDownGroupedItemsUseCase => {

  const orderByGroup = (list: GroupedDropDownMenuItemProps[], groupNames: (string | undefined)[]) => {
    const sortedList = [...list].sort((a: GroupedDropDownMenuItemProps, b: GroupedDropDownMenuItemProps) =>
      ((a?.group && b?.group) ? a.group.localeCompare(b.group) : 0) || a.text.localeCompare(b.text))
    groupNames.forEach((groupName) => {
      const index = sortedList.findIndex(option => option.group === groupName)
      if (index > -1 && sortedList[index]) {
        sortedList[index].showGroupLabel = true
      }
    })
    return sortedList
  }

  const orderByCurrentOrder = (list: GroupedDropDownMenuItemProps[], groupNames: (string | undefined)[]) => {
    let orderedItems: GroupedDropDownMenuItemProps[] = []
    groupNames.forEach((groupName) => {
      orderedItems = orderedItems.concat(list.filter(item => item.group === groupName))
      const index = orderedItems.findIndex(option => option.group === groupName)
      if (index > -1 && orderedItems[index]) {
        orderedItems[index].showGroupLabel = true
      }
    })
    return orderedItems
  }

  const groupedOptionList = computed(() => {
    const list = optionList.value.map<GroupedDropDownMenuItemProps>((option) => ({ ...option, showGroupLabel: false }))
    if (optionList.value.filter((option) => option?.group).length === 0) return list
    const groupNames = [...new Set(list.map(x => x.group))].filter(groupName => groupName)
    if (keepOrder.value) {
      return orderByCurrentOrder(list, groupNames)
    }
    return orderByGroup(list, groupNames)
  })
  return {
    groupedOptionList,
  }
}

export default useDropDownGroupedItems
